import { boot } from 'quasar/wrappers'
import { createGenaiService } from 'src/services/genai/genaiService'

// Service centralizado das rotas /genai — reutiliza a instância $axios da API
// panel (criada no boot/axios.js), que carrega o token de autorização.
export default boot(({ app }) => {
  app.config.globalProperties.$genaiService = createGenaiService(
    app.config.globalProperties.$axios
  )
})
